import api from "@/requests";

export const fetchBills = (payload = 1123) =>
  api.post("api/v1/MyRed/bills", payload);

/**
 * @typedef {Object} Prepayments
 * @property {number} paid
 * @property {string} plan_date
 * @property {number} to_pay
 * @property {boolean} is_persistent
 * @property {number?} calculated - Для калькулятора. Вычитаемая сумма от общей задолженности (to_pay)
 */

/**
 * @returns {Promise<Array<Prepayments>>}
 */
export const fetchPrepayments = () =>
  api.get("api/v1/MyRed/GetPrepayments", {
    showLoader: true,
  });

export const fetchPrepaymentCounter = () =>
api.get("api/v1/MyRed/GetDataForPrepaymentCounter", {
  showLoader: false,
});
export const fetchCalculator = () => api.get("/api/v1/Myred/PrepaymentCalculator");
